import { LuCircleAlert } from "react-icons/lu";
import TooltipComponent from "@/components/ui/tooltip.tsx";
import { useTranslations } from "@/features/translations/components/translations.tsx";

export default function PossibilityIndicator() {
    const t = useTranslations();

    return (
        <TooltipComponent trigger={<LuCircleAlert stroke="red" />}>
            <p>{t("not_available_for_selected_combination")}</p>
        </TooltipComponent>
    );
}
